import type { Control, FieldValues, Path } from 'react-hook-form'
import type { Feature } from '../../types'
import { BooleanFeatureValueInput } from './BooleanFeatureValueInput'
import { DefaultFeatureValueInput } from './DefaultFeatureValueInput'
import { IntegerFeatureValueInput } from './IntegerFeatureValueInput'

type FeatureValueInputAdapterProps<T extends FieldValues> = {
  control: Control<T>
  name: Path<T>
  selectedFeature?: Feature
}

export const FeatureValueInputAdapter = <T extends FieldValues>({ control, name, selectedFeature }: FeatureValueInputAdapterProps<T>) => {
  if (!selectedFeature) {
    return null
  }

  if (selectedFeature.type === 'boolean') {
    return <BooleanFeatureValueInput control={control} name={name} />
  }

  if (selectedFeature.type === 'integer') {
    return <IntegerFeatureValueInput control={control} name={name} />
  }

  return <DefaultFeatureValueInput control={control} name={name} />
}
